(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Escopo robusto por seção (funciona no Editor e no storefront)
  const host = document.currentScript?.closest('[id^="shopify-section"]') || document;
  const root = host.querySelector('[data-agbc]');
  if(!root || root.dataset.agbcInit === '1') return;
  root.dataset.agbcInit = '1';

  const frame   = root.querySelector('.agbc-frame');
  const track   = root.querySelector('[data-agbc-track]');
  const slides  = Array.from(root.querySelectorAll('.agbc-slide'));
  const dotsBox = root.querySelector('[data-agbc-dots]');

  const useCarousel = String(root.dataset.agbcCarousel) === 'true';
  const useAutoplay = String(root.dataset.agbcAutoplay) === 'true';
  const interval    = Math.max(1000, parseInt(root.dataset.agbcInterval || '4000', 10));
  const orientation = (root.dataset.agbcOrientation || 'horizontal').toLowerCase();
  const isVertical  = orientation === 'vertical';

  root.classList.toggle('agbc--vertical',   isVertical);
  root.classList.toggle('agbc--horizontal', !isVertical);

  let index = 0;
  let timer = null;
  const isMulti = slides.length > 1 && useCarousel;

  if (isMulti){
    root.classList.add('agbc--has-dots');
    slides.forEach((_, i)=>{
      const dot = document.createElement('button');
      dot.className = 'agbc-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Ir para o slide ' + (i+1));
      dot.addEventListener('click', ()=> goTo(i, true));
      dotsBox.appendChild(dot);
    });
  }

  // ===== Altura confiável antes do load do <img loading="lazy"> (evita 0px)
  function currentHeight(){
    const s = slides[index];
    if (!s) return frame.clientHeight || 0;
    const img = s.querySelector('img');
    if (img){
      const brH = Math.round(img.getBoundingClientRect().height);
      if (brH > 0) return brH;
      if (img.naturalWidth > 0){
        // Estima pela razão natural da imagem aplicada à largura do frame
        const ratio = img.naturalHeight / img.naturalWidth;
        const w = frame.clientWidth || s.clientWidth || root.clientWidth || window.innerWidth;
        const est = Math.round(Math.max(1, w * ratio));
        if (est > 0) return est;
      }
    }
    const h = s.offsetHeight || frame.clientHeight;
    return h > 0 ? h : 1;
  }

  function verticalOffsetFor(idx){
    let sum = 0;
    for (let i=0; i<idx; i++){
      const slide = slides[i];
      const img = slide.querySelector('img');
      let h = 0;
      if (img){
        const brH = Math.round(img.getBoundingClientRect().height);
        if (brH > 0) h = brH;
        else if (img.naturalWidth > 0){
          const ratio = img.naturalHeight / img.naturalWidth;
          const w = frame.clientWidth || slide.clientWidth || root.clientWidth || window.innerWidth;
          h = Math.round(Math.max(1, w * ratio));
        }
      }
      if (h === 0) h = slide.offsetHeight || frame.clientHeight || 0;
      sum += h;
    }
    return -Math.round(sum);
  }

  function baseOffsetOf(idx){
    return isVertical ? verticalOffsetFor(idx) : -(idx * frame.clientWidth);
  }

  function applyTransform(){
    const off = baseOffsetOf(index);
    track.style.transform = isVertical
      ? 'translate3d(0,' + off + 'px,0)'
      : 'translate3d(' + off + 'px,0,0)';

    const h = currentHeight();
    if (h && h >= 40) frame.style.height = h + 'px'; // não trava em 0px
  }

  function updateDots(){
    if(!isMulti) return;
    dotsBox.querySelectorAll('.agbc-dot').forEach((d, i)=>{
      d.setAttribute('aria-current', i === index ? 'true' : 'false');
      d.style.opacity = i === index ? '1' : '.85';
    });
  }

  function goTo(i, user){
    if(!slides.length) return;
    index = (i + slides.length) % slides.length;
    requestAnimationFrame(()=>{ applyTransform(); updateDots(); });
    if (user && isMulti && useAutoplay) restart();
  }

  function start(){
    if(!isMulti || !useAutoplay) return;
    stop();
    timer = setInterval(()=> goTo(index + 1, false), interval);
  }
  function stop(){ if (timer){ clearInterval(timer); timer = null; } }
  function restart(){ stop(); start(); }

  // ===== Swipe/Drag preservando clique no mobile
  let dragging = false, draggedEnough = false;
  let suppressClick = false;
  const DRAG_GUARD = 12; // px
  let startX = 0, startY = 0, delta = 0, baseAtStart = 0;

  function renderDrag(){
    const val = baseAtStart + delta;
    track.style.transform = isVertical
      ? 'translate3d(0,' + val + 'px,0)'
      : 'translate3d(' + val + 'px,0,0)';
  }

  function down(x, y){
    if (!isMulti) return;
    dragging = true;
    draggedEnough = false;
    suppressClick = false;
    startX = x; startY = y;
    baseAtStart = baseOffsetOf(index);
    root.classList.add('agbc--dragging');
    stop();
    // sem preventDefault -> mantém o click
  }

  function move(x, y){
    if (!dragging) return;
    const dx = x - startX;
    const dy = y - startY;
    delta = isVertical ? dy : dx;

    const primary   = isVertical ? Math.abs(dy) : Math.abs(dx);
    const secondary = isVertical ? Math.abs(dx) : Math.abs(dy);
    draggedEnough = primary > DRAG_GUARD && primary > secondary;

    if (draggedEnough) renderDrag();
  }

  function up(){
    if (!dragging) return;
    dragging = false;
    root.classList.remove('agbc--dragging');

    const size = isVertical ? frame.clientHeight : frame.clientWidth;
    const threshold = Math.max(40, size * 0.18);
    const moved = draggedEnough && Math.abs(delta) >= threshold ? (delta > 0 ? -1 : 1) : 0;

    delta = 0;
    if (moved) {
      suppressClick = true;
      goTo(index + moved, true);
    } else {
      applyTransform();
    }
    start();
  }

  root.addEventListener('click', (e)=>{
    if (suppressClick && e.target.closest('.agbc-link')) {
      e.preventDefault(); e.stopPropagation();
      suppressClick = false;
    }
  }, true);

  // Listeners (passive)
  frame.addEventListener('pointerdown', (e)=> down(e.clientX, e.clientY), { passive:true });
  frame.addEventListener('pointermove', (e)=> move(e.clientX, e.clientY), { passive:true });
  frame.addEventListener('pointerup',   up, { passive:true });
  frame.addEventListener('pointercancel', up, { passive:true });

  frame.addEventListener('mousedown', (e)=> down(e.clientX, e.clientY), { passive:true });
  window.addEventListener('mousemove', (e)=> move(e.clientX, e.clientY), { passive:true });
  window.addEventListener('mouseup',   up, { passive:true });

  frame.addEventListener('touchstart', (e)=> { const t=e.touches[0]; if(t) down(t.clientX, t.clientY); }, { passive:true });
  frame.addEventListener('touchmove',  (e)=> { const t=e.touches[0]; if(t) move(t.clientX, t.clientY); }, { passive:true });
  frame.addEventListener('touchend',   up, { passive:true });

  // ===== Reagir à troca de source e resize
  const onResize = ()=> { applyTransform(); };
  const imgs = Array.from(root.querySelectorAll('.agbc-slide img'));
  imgs.forEach(img=>{
    if (!img.complete) img.addEventListener('load', onResize, { once:false });
    img.addEventListener('error', onResize, { once:false });
  });

  const mql = window.matchMedia('(max-width: 1024px)');
  if (mql && mql.addEventListener) mql.addEventListener('change', onResize);
  else if (mql && mql.addListener)  mql.addListener(onResize);

  window.addEventListener('orientationchange', onResize);
  document.addEventListener('shopify:section:load', onResize);
  document.addEventListener('shopify:section:reorder', onResize);

  if (window.ResizeObserver) new ResizeObserver(onResize).observe(frame);
  else window.addEventListener('resize', onResize);

  // Boot
  requestAnimationFrame(()=>{ applyTransform(); updateDots(); start(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-section"] && !Shopify.designMode) return;
  try {
    
// Estado inicial + troca SOMENTE quando cruza o breakpoint (não em todo resize)
document.addEventListener('DOMContentLoaded', function () {
  var accs = Array.from(document.querySelectorAll('[data-ft-acc]'));
  if (!accs.length) return;

  var mq = window.matchMedia('(max-width: 768px)');

  function setStateForViewport() {
    // Desktop: mantém todos abertos
    if (!mq.matches) {
      accs.forEach(function (d) { d.setAttribute('open', ''); });
    } else {
      // Mobile: define o estado padrão (fechado) apenas na carga
      // e quando CRUZAR o breakpoint — depois deixa o usuário controlar
      accs.forEach(function (d) { d.removeAttribute('open'); });
    }
  }

  // Estado inicial
  setStateForViewport();

  // Só reage quando cruza o breakpoint (evita fechar ao rolar no mobile)
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', setStateForViewport);
  } else if (typeof mq.addListener === 'function') {
    // fallback iOS antigos
    mq.addListener(setStateForViewport);
  }

  // Nada de window.resize aqui — isso que causava o “fecha ao scroll”
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
(function(){
  const host = document.currentScript?.closest('[id^="shopify-section"]') || document;
  const root = host.querySelector('[data-agbc]');
  if(!root || root.dataset.agbcInit === '1') return;
  root.dataset.agbcInit = '1';

  const frame   = root.querySelector('.agbc-frame');
  const track   = root.querySelector('[data-agbc-track]');
  const slides  = Array.from(root.querySelectorAll('.agbc-slide'));
  const dotsBox = root.querySelector('[data-agbc-dots]');

  const useCarousel = String(root.dataset.agbcCarousel) === 'true';
  const useAutoplay = String(root.dataset.agbcAutoplay) === 'true';
  const interval    = Math.max(1000, parseInt(root.dataset.agbcInterval || '4000', 10));
  const orientation = (root.dataset.agbcOrientation || 'horizontal').toLowerCase();
  const isVertical  = orientation === 'vertical';

  root.classList.toggle('agbc--vertical',   isVertical);
  root.classList.toggle('agbc--horizontal', !isVertical);

  let index = 0;
  let timer = null;
  const isMulti = slides.length > 1 && useCarousel;

  if (isMulti){
    root.classList.add('agbc--has-dots');
    slides.forEach((_, i)=>{
      const dot = document.createElement('button');
      dot.className = 'agbc-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Ir para o slide ' + (i+1));
      dot.addEventListener('click', ()=> goTo(i, true));
      dotsBox.appendChild(dot);
    });
  }

  function currentHeight(){
    const s = slides[index];
    if (!s) return frame.clientHeight || 0;
    const img = s.querySelector('img');
    if (img){
      const brH = Math.round(img.getBoundingClientRect().height);
      if (brH > 0) return brH;
      if (img.naturalWidth > 0){
        const ratio = img.naturalHeight / img.naturalWidth;
        const w = frame.clientWidth || s.clientWidth || root.clientWidth || window.innerWidth;
        const est = Math.round(Math.max(1, w * ratio));
        if (est > 0) return est;
      }
    }
    const h = s.offsetHeight || frame.clientHeight;
    return h > 0 ? h : 1;
  }

  function verticalOffsetFor(idx){
    let sum = 0;
    for (let i=0; i<idx; i++){
      const slide = slides[i];
      const img = slide.querySelector('img');
      let h = 0;
      if (img){
        const brH = Math.round(img.getBoundingClientRect().height);
        if (brH > 0) h = brH;
        else if (img.naturalWidth > 0){
          const ratio = img.naturalHeight / img.naturalWidth;
          const w = frame.clientWidth || slide.clientWidth || root.clientWidth || window.innerWidth;
          h = Math.round(Math.max(1, w * ratio));
        }
      }
      if (h === 0) h = slide.offsetHeight || frame.clientHeight || 0;
      sum += h;
    }
    return -Math.round(sum);
  }

  function baseOffsetOf(idx){
    return isVertical ? verticalOffsetFor(idx) : -(idx * frame.clientWidth);
  }

  function applyTransform(){
    const off = baseOffsetOf(index);
    track.style.transform = isVertical
      ? 'translate3d(0,' + off + 'px,0)'
      : 'translate3d(' + off + 'px,0,0)';
    const h = currentHeight();
    if (h && h >= 40) frame.style.height = h + 'px';
  }

  function updateDots(){
    if(!isMulti) return;
    dotsBox.querySelectorAll('.agbc-dot').forEach((d, i)=>{
      d.setAttribute('aria-current', i === index ? 'true' : 'false');
      d.style.opacity = i === index ? '1' : '.85';
    });
  }

  function goTo(i, user){
    if(!slides.length) return;
    index = (i + slides.length) % slides.length;
    requestAnimationFrame(()=>{ applyTransform(); updateDots(); });
    if (user && isMulti && useAutoplay) restart();
  }

  function start(){
    if(!isMulti || !useAutoplay) return;
    stop();
    timer = setInterval(()=> goTo(index + 1, false), interval);
  }
  function stop(){ if (timer){ clearInterval(timer); timer = null; } }
  function restart(){ stop(); start(); }

  let dragging = false, draggedEnough = false;
  let suppressClick = false;
  const DRAG_GUARD = 12;
  let startX = 0, startY = 0, delta = 0, baseAtStart = 0;

  function renderDrag(){
    const val = baseAtStart + delta;
    track.style.transform = isVertical
      ? 'translate3d(0,' + val + 'px,0)'
      : 'translate3d(' + val + 'px,0,0)';
  }

  function down(x, y){
    if (!isMulti) return;
    dragging = true;
    draggedEnough = false;
    suppressClick = false;
    startX = x; startY = y;
    baseAtStart = baseOffsetOf(index);
    root.classList.add('agbc--dragging');
    stop();
  }

  function move(x, y){
    if (!dragging) return;
    const dx = x - startX;
    const dy = y - startY;
    delta = isVertical ? dy : dx;
    const primary   = isVertical ? Math.abs(dy) : Math.abs(dx);
    const secondary = isVertical ? Math.abs(dx) : Math.abs(dy);
    draggedEnough = primary > DRAG_GUARD && primary > secondary;
    if (draggedEnough) renderDrag();
  }

  function up(){
    if (!dragging) return;
    dragging = false;
    root.classList.remove('agbc--dragging');
    const size = isVertical ? frame.clientHeight : frame.clientWidth;
    const threshold = Math.max(40, size * 0.18);
    const moved = draggedEnough && Math.abs(delta) >= threshold ? (delta > 0 ? -1 : 1) : 0;
    delta = 0;
    if (moved) {
      suppressClick = true;
      goTo(index + moved, true);
    } else {
      applyTransform();
    }
    start();
  }

  root.addEventListener('click', (e)=>{
    if (suppressClick && e.target.closest('.agbc-link')) {
      e.preventDefault(); e.stopPropagation();
      suppressClick = false;
    }
  }, true);

  frame.addEventListener('pointerdown', (e)=> down(e.clientX, e.clientY), { passive:true });
  frame.addEventListener('pointermove', (e)=> move(e.clientX, e.clientY), { passive:true });
  frame.addEventListener('pointerup',   up, { passive:true });
  frame.addEventListener('pointercancel', up, { passive:true });

  const onResize = ()=> { applyTransform(); };
  const imgs = Array.from(root.querySelectorAll('.agbc-slide img'));
  imgs.forEach(img=>{
    if (!img.complete) img.addEventListener('load', onResize, { once:false });
    img.addEventListener('error', onResize, { once:false });
  });

  const mql = window.matchMedia('(max-width: 1024px)');
  if (mql && mql.addEventListener) mql.addEventListener('change', onResize);
  else if (mql && mql.addListener)  mql.addListener(onResize);

  window.addEventListener('orientationchange', onResize);
  document.addEventListener('shopify:section:load', onResize);
  document.addEventListener('shopify:section:reorder', onResize);
  if (window.ResizeObserver) new ResizeObserver(onResize).observe(frame);
  else window.addEventListener('resize', onResize);

  requestAnimationFrame(()=>{ applyTransform(); updateDots(); start(); });
})();

  } catch(e) { console.error(e); }
})();
})();
